import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import "./index.css";
import "./assets/css/globel.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./helpers";
import "./assets/fonts/Roboto-Regular.ttf";
import "./assets/fonts/Roboto-Bold.ttf";
import "./assets/fonts/Montserrat-Regular.ttf";
import "./assets/fonts/Montserrat-SemiBold.ttf";
import "./assets/fonts/Montserrat-Bold.ttf";
import "./assets/fonts/Montserrat-ExtraBold.ttf";
import "./assets/fonts/Montserrat-Black.ttf";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.REACT_APP_RECAPTCHA_V3_KEY}
    scriptProps={{
      async: true,
      defer: true,
    }}
    language="en"
    container={{
      element: "recaptcha-badge",
      parameters: {
        badge: "bottomleft", // ⬅️ THE IMPORTANT PART
        theme: "light",
      },
    }}
  >
    <Provider store={store}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
      <App />
      {/* </PersistGate> */}
    </Provider>
  </GoogleReCaptchaProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
